import { useDispatch } from 'react-redux';
import { addNotification } from '../store';
import { useGetPresentationBuildMutation } from '../services';
import { downloadBlobFile } from '@clatter/platform';

interface UsePresentationDownloadOptions {
  presentationId: number | string;
  displayName?: string;
}

export const usePresentationDownload = ({ presentationId, displayName }: UsePresentationDownloadOptions) => {
  const dispatch = useDispatch();
  const [downloadBuild, { isLoading: isDownloading }] = useGetPresentationBuildMutation();

  const handleDownload = async () => {
    try {
      dispatch(
        addNotification({
          type: 'success',
          message: `Preparing download for "${displayName || 'presentation'}". If it doesn't start automatically, check your browser settings.`,
        }),
      );

      const blob = await downloadBuild({ presentationId: Number(presentationId) }).unwrap();
      if (blob) {
        const filename = `${displayName || 'presentation'}.pptx`;
        downloadBlobFile(blob, filename, 100);
      }
    } catch (error) {
      console.error('Failed to download presentation:', error);
      dispatch(
        addNotification({
          type: 'error',
          message: 'Failed to download presentation',
        }),
      );
    }
  };

  return {
    handleDownload,
    isDownloading,
  };
};
